// IE 2026 10 05 / ODOO-5800 (fe-80; сверка боя prod_check18, находки A и E): ПОЛЕ-СПИСОК ID ЗАПИСЕЙ (AttrTags + relation_segment, значение — массив строк-id).
// Справочники модели сигналов (сегменты METRIC / REASON / SOLUTION) хранят связи списком id: doc.causes, doc.solutions, doc.signals. Чипсы-в-ячейке (AttrGrid,
// IE 2026 08 19 / ODOO-5512) писались под таблицу {use, title, …}: у элемента-строки подпись читалась store.get_value('<id>', undefined) — оператор `in` по строке
// бросал TypeError «Cannot use 'in' operator to search for 'undefined' in uncovered_demand» на каждой отрисовке формы записи, а колонка списка показывала id.
// Здесь — чистая логика без Vue / стора / DOM: элемент списка — запись-строка таблицы ИЛИ скаляр-id; название скаляра — из словаря сегмента ({id: {title}}).
// Юнит — tests/unit/tagIds.test.mjs
const isObj = (x) => !!(x && typeof x === 'object')

// элемент списка — голый id (строка / число), а не строка таблицы {use, title, …}
export function tagIds_isScalar(v) { return v !== null && v !== undefined && !isObj(v) && typeof v !== 'function' }

// поле — список id записей сегмента: AttrTags с relation_segment без колонок таблицы (attrs); сегмент | ''
export function tagIds_segment(attr) {
    if (!isObj(attr) || attr.attr_type !== 'AttrTags' || !attr.relation_segment) return ''
    return (Array.isArray(attr.attrs) && attr.attrs.length) ? '' : String(attr.relation_segment)
}

// описание ссылки для словаря сегмента (store.get_itemsSource) и подбора записей; не список id — null
export function tagIds_linkAttr(attr) {
    const seg = tagIds_segment(attr)
    return seg ? { attr_type: 'AttrLink', relation_segment: seg, binding: 'id' } : null
}

// название записи по id из словаря сегмента ({id: {title}}); записи нет — сам id
export function tagIds_title(id, ids = null) {
    const s = id === null || id === undefined ? '' : String(id)
    const rec = ids && isObj(ids) ? ids[s] : null
    const title = isObj(rec) ? rec.title : (typeof rec === 'string' ? rec : '')
    return (typeof title === 'string' && title) ? title : s
}

// подпись чипса: строка таблицы — её title, иначе значение колонки-подписи (getValue(row, binding)); скаляр-id — название из словаря. Никогда не бросает
export function tagIds_label(field, binding, getValue, ids = null) {
    if (field === null || field === undefined) return ''
    if (tagIds_isScalar(field)) return tagIds_title(field, ids)
    if (field.title) return String(field.title)
    if (binding === undefined || binding === null || binding === '' || typeof getValue !== 'function') return ''
    const v = getValue(field, binding)
    return v === null || v === undefined ? '' : v
}

// id элемента для сравнения «уже выбран»: скаляр — он сам; строка таблицы — значение колонки-подписи; выключенная строка — null
export function tagIds_key(row, binding, getValue) {
    if (row === null || row === undefined) return null
    if (tagIds_isScalar(row)) return row
    if (row.use === false) return null
    return (binding === undefined || binding === null || typeof getValue !== 'function') ? null : getValue(row, binding)
}

// текст ячейки списка: названия через запятую; строки таблицы — как gridText_tags (title / valueStr / value, выключенные пропускаются); скаляры — по словарю
export function tagIds_text(value, ids = null) {
    if (value === null || value === undefined || value === '') return ''
    const list = Array.isArray(value) ? value : (typeof value === 'string' ? value.split(',').map(s => s.trim()) : [value])
    const out = []
    for (const v of list) {
        if (isObj(v)) {
            if (v.use === false) continue
            const s = v.title ?? v.valueStr ?? v.value ?? ''
            if (s !== '' && s !== null && s !== undefined) out.push(String(s))
        } else if (v !== null && v !== undefined && v !== '') out.push(tagIds_title(v, ids))
    }
    return out.join(', ')
}

// id списка, которых ещё нет в словаре (их названия надо запросить)
export function tagIds_unknown(value, ids = null) {
    const list = Array.isArray(value) ? value : []
    return [...new Set(list.filter(v => tagIds_isScalar(v) && v !== '' && !(ids && ids[String(v)])).map(String))]
}

// копия массива для записи в документ: у строк таблицы снимается служебный _meta, скаляры остаются как есть (раньше строка-id разворачивалась в {0: 'u', 1: 'n', …})
export function tagIds_commit(arr) {
    return (Array.isArray(arr) ? arr : []).map(r => { if (!isObj(r)) return r; const { _meta, ...row } = r; return row })
}

// снять элемент: скаляр — убрать из массива (на месте), строка таблицы — use = false; → true, если что-то изменилось
export function tagIds_remove(arr, item) {
    if (!Array.isArray(arr)) return false
    const i = arr.indexOf(item)
    if (i === -1) return false
    if (tagIds_isScalar(item)) arr.splice(i, 1)
    else item.use = false
    return true
}

// добавить id в список id (на месте), без повторов; → true, если добавлен
export function tagIds_add(arr, id) {
    const s = id === null || id === undefined ? '' : String(id).trim()
    if (!Array.isArray(arr) || !s || arr.some(v => tagIds_isScalar(v) && String(v) === s)) return false
    arr.push(s)
    return true
}

export default { tagIds_isScalar, tagIds_segment, tagIds_linkAttr, tagIds_title, tagIds_label, tagIds_key, tagIds_text, tagIds_unknown, tagIds_commit, tagIds_remove, tagIds_add }
